<template>
  <div>
    <PromotionHeader header="จัดการโปรโมชั่นสินค้าใกล้หมดอายุ" :img_header="header_image" link_back="stock/storage/expirestorage"/>
    <Promotion_manage_exp/>
  </div>
</template>

<script>
import PromotionHeader from "@/components/admin/stock/storage_promotion/header_promotion/PromotionHeader";
import Promotion_manage_exp from "@/components/admin/stock/storage_promotion/Promotion_manage_exp";
import HeaderImage from "@/assets/time.png";
export default {
  name: "ExpirePromotion",
  components: {
    Promotion_manage_exp,
    PromotionHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
